export default {"src":"/_next/static/media/gym.ac46139d.svg","height":40,"width":67,"blurWidth":0,"blurHeight":0};